import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { HeartButton } from "@/components/HeartButton";
import { PRODUCTS } from "@/data/content";

export const ProductCard = ({ product, index, tall = false, horizontal = false }) => {
  const addBtn = (
    <HeartButton
      name={product.name}
      price={product.price}
      testid={`product-heart-${index}`}
    />
  );

  if (horizontal) {
    return (
      <Reveal delay={Math.min(index * 0.06, 0.3)} className="h-full">
        <div
          data-testid={`product-card-${index}`}
          className="group h-full rounded-2xl border border-kiki-line bg-white overflow-hidden hover:border-kiki-gold/40 transition-colors duration-300 flex flex-row"
        >
          <div className="relative w-2/5 shrink-0 overflow-hidden bg-kiki-surface">
            <img
              src={product.img}
              alt={product.name}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
          </div>
          <div className="p-6 flex flex-col flex-1">
            <p className="text-[10px] uppercase tracking-[0.25em] font-mono text-kiki-gold font-semibold">{product.shop}</p>
            <h3 className="font-display text-2xl font-medium text-kiki-ink mt-1.5 leading-tight">{product.name}</h3>
            <p className="text-sm text-kiki-muted mt-2 font-light leading-relaxed flex-1">{product.includes}</p>
            <div className="mt-4 flex items-center justify-between gap-3">
              <span className="font-display text-xl text-kiki-gold font-medium">{product.price}</span>
              {addBtn}
            </div>
          </div>
        </div>
      </Reveal>
    );
  }

  return (
    <Reveal delay={Math.min(index * 0.06, 0.3)} className="h-full">
      <div
        data-testid={`product-card-${index}`}
        className="group h-full rounded-2xl border border-kiki-line bg-white overflow-hidden hover:border-kiki-gold/40 transition-colors duration-300 flex flex-col"
      >
        <div className={`relative ${tall ? "h-52" : "h-40"} overflow-hidden bg-kiki-surface`}>
          <img
            src={product.img}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="p-6 flex flex-col flex-1">
          <p className="text-[10px] uppercase tracking-[0.25em] font-mono text-kiki-gold font-semibold">{product.shop}</p>
          <h3 className="font-display text-2xl font-medium text-kiki-ink mt-1.5 leading-tight">{product.name}</h3>
          <p className="text-sm text-kiki-muted mt-2 font-light leading-relaxed flex-1">{product.includes}</p>
          <div className="mt-4 flex items-center justify-between gap-3">
            <span className="font-display text-xl text-kiki-gold font-medium">{product.price}</span>
            {addBtn}
          </div>
        </div>
      </div>
    </Reveal>
  );
};

const StoreSection = () => (
  <section id="store" data-testid="store-section" className="relative py-16 sm:py-24 bg-kiki-surface/60">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal><Eyebrow>Ready-to-use templates & kits</Eyebrow></Reveal>
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mt-3 mb-8">
        <Reveal delay={0.1}>
          <h2 className="font-display text-4xl sm:text-5xl font-medium tracking-tight text-kiki-ink leading-[1.05]">
            Digital product shop
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <Link
            data-testid="store-see-all-link"
            to="/store"
            className="inline-flex items-center gap-1.5 text-sm font-outfit font-semibold text-kiki-gold hover:text-kiki-goldhover transition-colors duration-300"
          >
            See all {PRODUCTS.length} bundles <ArrowUpRight className="w-4 h-4" />
          </Link>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {PRODUCTS.slice(0, 2).map((p, i) => (
          <ProductCard key={p.name} product={p} index={i} horizontal />
        ))}
      </div>
      <p className="mt-6 text-xs text-kiki-muted font-light">
        Tap the heart to shortlist a bundle. Individual templates, calculators and trackers also available from ₹99 across six product shops.
      </p>
    </div>
  </section>
);

export default StoreSection;
